import { CookieRefreshIcon } from './CookieRefreshIcon';

/**
 * author: Colton Wiscombe
 * id 184857B9-228F-4DD2-AF53-603277AEEB7F
 * name cookie-refresh
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cookie-refresh.svg
 * tags
 * - Food / Drink 
 */
export const BiscuitRefreshIcon = CookieRefreshIcon;
export default BiscuitRefreshIcon